import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-xs text-gray-500 mt-1"
}
const _hoisted_2 = { class: "flex flex-col justify-between h-full" }
const _hoisted_3 = { class: "px-6 md:px-8 pt-6" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_6 = { class: "text-gray-900 font-medium" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-sm overflow-hidden" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = {
  key: 0,
  class: "text-xs font-mono block"
}
const _hoisted_14 = {
  key: 0,
  class: "block"
}
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = { class: "text-sm" }

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import NeuePagination from '@/components/neue/NeuePagination.vue'
import NeueTablist from '@/components/neue/NeueTablist.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import { useEntitlements } from '@/composables/useEntitlements'
import { useFulfillmentWizardAccess } from '@/composables/useFulfillmentWizardAccess'
import { useToast } from '@/composables/useToast'
import { WIZARD_PATH } from '@/config/fulfillmentWizardSteps'
import { serverDayToDateObject } from '@/helpers/dates'
import { limitMessage, limitReached, planLimitError } from '@/helpers/planLimits'
import {
  fulfillmentTypeBadgeTheme,
  fulfillmentTypeLabel,
  fulfillmentTypeOptions
} from '@/models/fulfillmentMethodTypes'
import api from '@/store/api'
import { mapRelationships } from '@/store/mappers'


export default {
  __name: 'FulfillmentMethodList',
  setup(__props) {

const fulfillmentColumns = [
  { width: '60px' },
  { width: 'minmax(120px, 2fr)' },
  { width: 'minmax(100px, 1fr)' },
  { width: 'minmax(140px, 2fr)' },
  { width: 'minmax(100px, 1fr)' },
  { width: '80px' },
  { width: '80px' }
]

const data = ref({
  fulfillmentMethods: []
})

const { limit } = useEntitlements()
const { showToast } = useToast()

const modalOpen = ref(false)
const newMethodType = ref(null)
const newMethodName = ref('')
const wizardEnabled = useFulfillmentWizardAccess()

// At the plan limit the modal opens so the merchant sees why nothing can be added.
const startNew = () => {
  if (wizardEnabled.value && !methodsLimitReached.value) router.push(WIZARD_PATH)
  else modalOpen.value = true
}
const loading = ref(true)

const local = ref({
  status: {
    fulfillmentMethods: {
      error: false,
      currentPage: 0,
      pageSize: 8
    }
  }
})

const router = useRouter()
const store = useStore()
const merchantTZ = computed(() => {
  return store.state.loggedInUser.attributes.time_zone_short
})

const getFulfillmentMethods = () => {
  const includes = ['stores', 'fulfillment_slots', 'fulfillment_method_store_pairs']
  api.call('GET', `fulfillment_methods?included=${includes.join(',')}`).then(r => {
    data.value.fulfillmentMethods = r.data.data
    loading.value = false
  })
}

onMounted(() => {
  getFulfillmentMethods()
})

const onPageChange = e => {
  local.value.status.fulfillmentMethods.currentPage = e
}

const prevPage = ret => {
  local.value.status.fulfillmentMethods.currentPage--
  ret()
}

const nextPage = ret => {
  local.value.status.fulfillmentMethods.currentPage++
  ret()
}

const formatDeliveryWindowTime = window =>
  new Intl.DateTimeFormat('en-US', {
    month: 'numeric',
    day: 'numeric'
  }).format(serverDayToDateObject(window.date))

const getStores = stores => {
  return mapRelationships(stores)
}

const methodsLimit = computed(() => limit('fulfillment_methods'))
const activeMethodCount = computed(
  () => data.value.fulfillmentMethods.filter(m => m.attributes.is_active !== false).length
)
const methodsLimitReached = computed(() => limitReached(methodsLimit.value, activeMethodCount.value))
const methodsLimitMessage = computed(() => limitMessage('fulfillment methods', methodsLimit.value))
const canAddMethod = computed(() => !methodsLimitReached.value && newMethodType.value && newMethodName.value.trim())

const create = async () => {
  if (!canAddMethod.value) return

  try {
    const response = await api.call('POST', 'fulfillment_methods', {
      fulfillment_method: { name: newMethodName.value.trim(), type: newMethodType.value }
    })
    router.push('/store/fulfillment-methods/' + response.data.data.id)
  } catch (error) {
    showToast(planLimitError(error) || 'Could not create the fulfillment method', { type: 'error' })
  }
}

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_InputField = _resolveComponent("InputField")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_router_link = _resolveComponent("router-link")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Fulfillment methods" }, {
        right: _withCtx(() => [
          (methodsLimitReached.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(methodsLimitMessage.value), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_NeueButton, {
            type: methodsLimitReached.value ? 'inactive' : 'primary',
            title: methodsLimitReached.value ? methodsLimitMessage.value : undefined,
            onClick: startNew
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" New ", -1)
            ]))]),
            _: 1
          }, 8, ["type", "title"])
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createVNode(_component_TheModal, {
        "is-open": modalOpen.value,
        "modal-title": "New fulfillment method",
        onCloseModal: _cache[3] || (_cache[3] = $event => (modalOpen.value = false))
      }, {
        main: _withCtx(() => [
          _createVNode(_component_FormSection, null, {
            default: _withCtx(() => [
              _createVNode(_component_FormElement, null, {
                default: _withCtx(() => [
                  _createVNode(_component_InputField, {
                    modelValue: newMethodName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((newMethodName).value = $event)),
                    name: "Fulfillment method name"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_FormElement, null, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectInput, {
                    modelValue: newMethodType.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((newMethodType).value = $event)),
                    options: _unref(fulfillmentTypeOptions),
                    name: "Fulfillment method type"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_NeueButton, {
            type: "secondary",
            onClick: _cache[2] || (_cache[2] = $event => (modalOpen.value = false))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_NeueButton, {
            type: canAddMethod.value ? 'primary' : 'inactive',
            title: methodsLimitReached.value ? methodsLimitMessage.value : undefined,
            onClick: create
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Add ", -1)
            ]))]),
            _: 1
          }, 8, ["type", "title"])
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_NeueLoading, { loading: loading.value }, {
            default: _withCtx(() => [
              (data.value.fulfillmentMethods.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(NeueTablist, null, {
                        head: _withCtx(() => [
                          _createVNode(TablistHeader, null, {
                            default: _withCtx(() => [
                              _createVNode(TablistGrid, {
                                columns: fulfillmentColumns,
                                header: ""
                              }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createElementVNode("div", null, "Order", -1),
                                  _createElementVNode("div", null, "Method", -1),
                                  _createElementVNode("div", null, "Store", -1),
                                  _createElementVNode("div", null, "Upcoming slots", -1),
                                  _createElementVNode("div", null, "Zipcodes", -1),
                                  _createElementVNode("div", null, "Type", -1),
                                  _createElementVNode("div", null, "Status", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.fulfillmentMethods.slice(
                      local.value.status.fulfillmentMethods.currentPage * local.value.status.fulfillmentMethods.pageSize,
                      local.value.status.fulfillmentMethods.currentPage * local.value.status.fulfillmentMethods.pageSize +
                        local.value.status.fulfillmentMethods.pageSize
                    ), (item) => {
                            return (_openBlock(), _createBlock(TablistRow, {
                              key: item.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(TablistGrid, { columns: fulfillmentColumns }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.attributes.order), 1),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_router_link, {
                                        to: `/store/fulfillment-methods/${item.id}`,
                                        class: "text-sm font-medium text-blue-600 hover:text-blue-900 break-words"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.attributes.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]),
                                      (item.attributes.over_plan_limit)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "ml-2 px-2 text-xs leading-5 font-semibold rounded-full bg-gray-200 text-gray-700",
                                            title: methodsLimitMessage.value
                                          }, " Over plan limit ", 8, _hoisted_7))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                      (getStores(item.relationships?.stores?.data))
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getStores(item.relationships.stores.data), (store) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: `store-${store.id}`
                                              }, [
                                                _createVNode(_component_router_link, {
                                                  class: "cursor-pointer text-blue-600 hover:text-blue-900",
                                                  to: `/store/stores/${store.id}`
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(store.attributes.store_name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"])
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                      (item.attributes?.upcoming_windows)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.attributes.upcoming_windows, (upcomingSlot, slotIndex) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: `slot-${slotIndex}`,
                                                class: "text-xs mb-1 font-mono truncate"
                                              }, _toDisplayString(formatDeliveryWindowTime(upcomingSlot)) + " (" + _toDisplayString(upcomingSlot.friendly_time) + " " + _toDisplayString(merchantTZ.value) + ") ", 1))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                      (item.attributes.eligible_zip_codes.length)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.attributes.eligible_zip_codes.slice(0, 5), (zipcode, zipcodeIndex) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: `zipcode-${zipcodeIndex}`
                                              }, _toDisplayString(zipcode), 1))
                                            }), 128)),
                                            (item.attributes.eligible_zip_codes.length > 5)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, " +" + _toDisplayString(item.attributes.eligible_zip_codes.length - 5) + " more ", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass([
                            'px-2 capitalize inline-flex text-xs leading-5 font-semibold rounded-full',
                            _unref(fulfillmentTypeBadgeTheme)(item.attributes.type)
                          ])
                                      }, _toDisplayString(_unref(fulfillmentTypeLabel)(item.attributes.type)), 3)
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass([
                            'px-2 capitalize inline-flex text-xs leading-5 font-semibold rounded-full',
                            item.relationships.stores.data.length
                              ? 'bg-green-100 text-green-800'
                              : 'bg-red-100 text-red-800'
                          ])
                                      }, _toDisplayString(item.relationships.stores.data.length ? 'Active' : 'Inactive'), 3)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    (data.value.fulfillmentMethods.length > local.value.status.fulfillmentMethods.pageSize)
                      ? (_openBlock(), _createBlock(NeuePagination, {
                          key: 0,
                          size: data.value.fulfillmentMethods.length,
                          from: local.value.status.fulfillmentMethods.currentPage * local.value.status.fulfillmentMethods.pageSize + 1,
                          to: 
                  Math.min(
                    (local.value.status.fulfillmentMethods.currentPage + 1) * local.value.status.fulfillmentMethods.pageSize,
                    data.value.fulfillmentMethods.length
                  )
                ,
                          onPrev: prevPage,
                          onNext: nextPage
                        }, null, 8, ["size", "from", "to"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!data.value.fulfillmentMethods.length)
                ? (_openBlock(), _createBlock(_component_NeueWell, {
                    key: 1,
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EmptyState, { plural: "fulfillment methods" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

}